// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"a32339da","455":"52983392","977":"9341c53a"}[chunkId] + ".chunk.js";
};